<template>
  <div>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <table class="table table-hover  table-responsive-md" v-if="loaded">
      <thead>
        <tr style="background-color:#eee;">
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Required</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="employee in worklogs" :key="employee.id">
          <td>{{ employee.name_first + ' ' + employee.name_last }}</td>
          <td><a :href="'mailto:' + employee.email">{{ employee.email }}</a></td>
          <td><a :href="'tel:' + employee.phone_mobile">{{ employee.phone_mobile }}</a></td>
          <!-- We require a worklog -->
          <td v-if="employee.worklog_required">
            <span class="badge badge-danger">Required</span>
          </td>
          <!-- We don't require a worklog -->
          <td v-if="!employee.worklog_required">
            <span class="badge badge-success">Submitted</span>
          </td>
          <!-- We require a worklog -->
          <td v-if="employee.worklog_required">
            <router-link :to="'/worklogs/' + employee.id" class="btn btn-sm btn-primary">Submit</router-link>
          </td>
          <!-- We don't require a worklog -->
          <td v-if="!employee.worklog_required">
            <a :href="employee.worklogs.pdf_url" target="_blank" class="btn btn-sm btn-primary" v-if="employee.worklogs.pdf_url">View</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'WorkLogsTable',
  data () {
    return {
      loaded: false,
      worklogs: []
    };
  },
  methods: {
    loadWorklogs () {
      this.loaded = false;
      this.axios.get('/worklogs/students').then(rsp => {
        this.worklogs = rsp.data;
        this.loaded = true;
      }).catch((err) => this.$snotify.error(err.response.data.message, 'Worklogs'));
    }
  },
  mounted () {
    this.loadWorklogs();
  }
};
</script>

<style scoped>

</style>